import React from 'react';
import SiteFooter from './SiteFooter';

function Footer() {
    return <SiteFooter variant="app" />;
}

export default Footer;